import { render, staticRenderFns } from "./MenuModifier.vue?vue&type=template&id=134ec6fb&scoped=true&"
import script from "./MenuModifier.vue?vue&type=script&lang=js&"
export * from "./MenuModifier.vue?vue&type=script&lang=js&"
import style0 from "./MenuModifier.vue?vue&type=style&index=0&id=134ec6fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134ec6fb",
  null
  
)

export default component.exports